import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Testimonials.css';

const Testimonials: React.FC = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 'testimonial1',
      name: t('testimonials.cards.0.name'),
      role: t('testimonials.cards.0.role'),
      content: t('testimonials.cards.0.text')
    },
    {
      id: 'testimonial2',
      name: t('testimonials.cards.1.name'),
      role: t('testimonials.cards.1.role'),
      content: t('testimonials.cards.1.text')
    },
    {
      id: 'testimonial3',
      name: t('testimonials.cards.2.name'),
      role: t('testimonials.cards.2.role'),
      content: t('testimonials.cards.2.text')
    },
    {
      id: 'testimonial4',
      name: t('testimonials.cards.3.name'),
      role: t('testimonials.cards.3.role'),
      content: t('testimonials.cards.3.text')
    },
    {
      id: 'testimonial5',
      name: t('testimonials.cards.4.name'),
      role: t('testimonials.cards.4.role'),
      content: t('testimonials.cards.4.text')
    },
    {
      id: 'testimonial6',
      name: t('testimonials.cards.5.name'),
      role: t('testimonials.cards.5.role'),
      content: t('testimonials.cards.5.text')
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <h2>{t('testimonials.title')}</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <p>{testimonial.content}</p>
              </div>
              <div className="testimonial-author">
                <h4>{testimonial.name}</h4>
                <p>{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 